// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5fe120be","239":"a269c1fb","455":"2e959412"}[chunkId] + ".chunk.js";
};